let isRegistered = false

export const isFormSubmitShortcut = (event: KeyboardEvent): boolean => {
  return (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 's'
}

const isVisible = (element: HTMLElement): boolean => {
  if (typeof element.checkVisibility === 'function') {
    return element.checkVisibility({
      checkOpacity: true,
      checkVisibilityCSS: true,
    })
  }

  return element.getClientRects().length > 0
}

const resolveFormFromTarget = (target: EventTarget | null): HTMLFormElement | null => {
  if (!(target instanceof Element)) {
    return null
  }

  return target.closest('form')
}

const resolvePrimaryForm = (): HTMLFormElement | null => {
  const root = document.querySelector('main') ?? document.body

  return resolveVisibleForm(root)
}

const resolveOpenModal = (): HTMLElement | null => {
  return document.querySelector<HTMLElement>('[data-modal]')
}

const resolveVisibleForm = (root: ParentNode): HTMLFormElement | null => {
  const forms = Array.from(root.querySelectorAll('form')).filter(
    (form): form is HTMLFormElement => form instanceof HTMLFormElement && isVisible(form),
  )

  const formsWithSubmit = forms.filter(
    (form) => form.querySelector('button[type="submit"], input[type="submit"]') !== null,
  )

  return formsWithSubmit[0] ?? forms[0] ?? null
}

const resolveForm = (target: EventTarget | null): HTMLFormElement | null => {
  const modal = resolveOpenModal()

  if (modal) {
    const targetForm = resolveFormFromTarget(target)

    if (targetForm && modal.contains(targetForm)) {
      return targetForm
    }

    return resolveVisibleForm(modal)
  }

  return resolveFormFromTarget(target) ?? resolvePrimaryForm()
}

export const useFormSubmitShortcut = (): void => {
  if (isRegistered) {
    return
  }

  document.addEventListener(
    'keydown',
    (event) => {
      if (!isFormSubmitShortcut(event)) {
        return
      }

      event.preventDefault()

      const form = resolveForm(event.target)

      if (!form) {
        return
      }

      form.requestSubmit()
    },
    { capture: true },
  )

  isRegistered = true
}
